import { AsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { AttendedECUDto } from '../../../features/firmware-management/dtos/attended-ECU.dto';
import { axiosInstance } from '../../../features/shared/api/axios-instance';
import { createPathParams } from '../../../features/shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../../features/shared/utils/endpoints-file.utils';
import { withMandant } from '../with-mandant/with-mandant.thunk';
import { GetEcusByModelModel } from './models/get-ecus-by-model.model';

export const getEcusByModel = <TReturnType>(
  mapper: (dto: AttendedECUDto) => TReturnType
): AsyncThunk<TReturnType[], GetEcusByModelModel, Record<string, unknown>> =>
  withMandant<GetEcusByModelModel, TReturnType[]>(
    Endpoints.GET_ECUS_BY_MODEL,
    'get-ecus-by-model',
    async ({ args, endpoint }) => {
      if (!args.modelIds?.length) {
        return new Promise(resolve => resolve([]));
      }

      const urls: string[] = [];

      args.modelIds.forEach(modelId => {
        urls.push(
          createPathParams<'modelId'>(endpoint, {
            modelId,
          })
        );
      });

      return await axios.all(urls.map(url => axiosInstance.get(url))).then(
        axios.spread((...results) => {
          const ecusDtoArray: TReturnType[] = [];
          results.forEach(result =>
            result.data.forEach((ecuItem: AttendedECUDto) =>
              ecusDtoArray.push(mapper(ecuItem))
            )
          );

          return ecusDtoArray;
        })
      );
    }
  );
